import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import "swiper/css/bundle";
import "swiper/css/thumbs";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./slider.css";
import {
  Thumbs,
  Pagination,
  Mousewheel,
  Keyboard,
  Autoplay,
} from "swiper/modules";

const Slider = () => {
  const navigate = useNavigate();
  return (
    <div className="slider-container">
      <Swiper
        pagination={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        speed={1000}
        modules={[Pagination, Mousewheel, Keyboard, Thumbs, Autoplay]}
        loop={true}
        className="main-swiper non-selectable"
      >
        <SwiperSlide>
          <img
            src="/slides/slide-bridge.png"
            alt="Product 1"
            onClick={() =>
              navigate("/card/bridge/a03bc7e7-c40c-48fc-b175-44fb9572b6cb")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/slide-flamingo.png"
            alt="Product 2"
            onClick={() =>
              navigate("/card/flamingo/526a6e8e-c285-457a-be8c-f4acda92bc2a")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/slide-money.png"
            alt="Product 3"
            onClick={() =>
              navigate("/card/money/53cfa9dc-a0da-4d16-acdb-067b8b0e2343")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/slide-baggage.png"
            alt="Product 4"
            onClick={() =>
              navigate("/card/baggage/66c635fd-e4ae-4301-a616-ea647b7e48a3")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/slide-f1-car.png"
            alt="Product 5"
            onClick={() =>
              navigate("/card/F1-car/2b4ab0aa-c808-4abb-b4f4-09f53cd8cb05")
            }
          />
        </SwiperSlide>
      </Swiper>

      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        centeredSlides={false}
        pagination={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        speed={1000}
        modules={[Pagination, Mousewheel, Keyboard, Thumbs, Autoplay]}
        loop={true}
        className="small-swiper non-selectable"
      >
        <SwiperSlide>
          <img
            src="/slides/mini-slide-bridge.png"
            alt="Product 1"
            onClick={() =>
              navigate("/card/bridge/a03bc7e7-c40c-48fc-b175-44fb9572b6cb")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/mini-slide-flamingo.png"
            alt="Product 2"
            onClick={() =>
              navigate("/card/flamingo/526a6e8e-c285-457a-be8c-f4acda92bc2a")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/mini-slide-money.png"
            alt="Product 3"
            onClick={() =>
              navigate("/card/money/53cfa9dc-a0da-4d16-acdb-067b8b0e2343")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/mini-slide-baggage.png"
            alt="Product 4"
            onClick={() =>
              navigate("/card/baggage/66c635fd-e4ae-4301-a616-ea647b7e48a3")
            }
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src="/slides/mini-slide-f1-car.png"
            alt="Product 5"
            onClick={() =>
              navigate("/card/F1-car/2b4ab0aa-c808-4abb-b4f4-09f53cd8cb05")
            }
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Slider;
